import React from 'react'
import {PlayerColor} from '@colonist/game-states'
// eslint-disable-next-line no-restricted-imports
import {GameColor} from '../../../../../code/client/shared/scripts/GameColor'
import styles from './UIGameMobileTimerBar.module.scss'
import clsx from 'clsx'

export interface UIGameMobileTimerBarProps {
    className?: string
    currentTurnPlayerColor: PlayerColor
    timeLeftPercentage: number
    isAnimated: boolean
}

// TODO: className input should have bottom: var(--safe-area-inset-bottom) when called from the mobile app
export function UIGameMobileTimerBar({
    className,
    currentTurnPlayerColor,
    timeLeftPercentage,
    isAnimated,
}: UIGameMobileTimerBarProps) {
    const backgroundColor = GameColor.getPlayerBGDarkHashForMobile(currentTurnPlayerColor)
    const tickerStyle: React.CSSProperties = {
        backgroundColor: backgroundColor,
        width: `${timeLeftPercentage}%`,
    }

    return (
        <div className={clsx(styles.mobileTimerBarParent, className)}>
            <div
                className={clsx(styles.mobileTimerBar, isAnimated ? styles.active : '')}
                style={tickerStyle}>
            </div>
        </div>
    )
}
